export default __webpack_public_path__ + "db810a5f66858fb4bad47d5b7ec25389.svg";